



















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Applyin extends Vue {
  @Prop({ default: "#000" }) readonly bg!: string;
  @Prop({ default: "#fff" }) readonly color!: string;
}
